import { useMutation } from "react-fetching-library";

const useStepStatushooks = () => {
  // @ts-ignore
  // const users_detail = JSON.parse(localStorage.getItem("users_detail"));
  const ModuleStatusHooksAction: any = () => ({
    method: "GET",
    endpoint: `/v1/application/details`,
  });
  const {
    mutate: ModuleStatusHooksMutate,
    error,
    payload,
  } = useMutation(ModuleStatusHooksAction);

  return {
    ModuleStatusHooksMutate,
    payload,
    error,
  };
};
////////////////////Send OTP

const useSendOTPhooks = () => {
  const SendOTPAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/login/send-otp`,
    dataType: "jsonp",
    body: formValues,
  });
  const { mutate: SendOTPMutate, error, payload } = useMutation(SendOTPAction);
  return {
    SendOTPMutate,
    payload,
    error,
  };
};

const useVerifyOTPhooks = () => {
  const VerifyOTPAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/login/verify-otp`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: VerifyOTPMutate,
    error,
    payload,
  } = useMutation(VerifyOTPAction);
  return {
    VerifyOTPMutate,
    payload,
    error,
  };
};

// validate DOB for 2 way authentication

const useTwoWayAuthVerificationhooks = () => {
  const VerifyDOBAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/login/verify-birth-year`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: VerifyDOBMutate,
    error,
    payload,
  } = useMutation(VerifyDOBAction);
  return {
    VerifyDOBMutate,
    payload,
    error,
  };
};
// send-otp mobile update
const useSendOTPNewMobilehooks = () => {
  const SaveSendOTPNewMobileUpdateAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/mobile/send-otp`,
    body: {
      pan: formValues.pan,
      old_mobile_number: formValues.old_mobile_number,
      new_mobile: formValues.new_mobile_number,
    },
  });
  const {
    mutate: SaveSendOTPNewMobileUpdateMutate,
    error,
    payload,
  } = useMutation(SaveSendOTPNewMobileUpdateAction);

  return {
    SaveSendOTPNewMobileUpdateMutate,
    payload,
    error,
  };
};
// verify-otp mobile update
const useVerifyOTPNewMobileMutate = () => {
  const SaveVerifyOTPNewMobileUpdateAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/mobile/verify-otp`,
    body: {
      pan: formValues.pan,
      otp: formValues.otpCode,
      new_mobile: formValues.new_mobile_number,
    },
  });
  const {
    mutate: SaveVerifyOTPNewMobileUpdateMutate,
    error,
    payload,
  } = useMutation(SaveVerifyOTPNewMobileUpdateAction);

  return {
    SaveVerifyOTPNewMobileUpdateMutate,
    payload,
    error,
  };
};

const useSendOTPNewEmailhooks = () => {
  const SaveSendOTPNewMobileUpdateAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/email/send-otp`,
    body: {
      pan: formValues.pan,
      application_number: formValues.application_number,
      new_email: formValues.new_mobile_number,
    },
  });
  const {
    mutate: SaveSendOTPNewMobileUpdateMutate,
    error,
    payload,
  } = useMutation(SaveSendOTPNewMobileUpdateAction);

  return {
    SaveSendOTPNewMobileUpdateMutate,
    payload,
    error,
  };
};
const useVerifyOTPNewEmailMutate = () => {
  const SaveVerifyOTPNewMobileUpdateAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/email/verify-otp`,
    body: {
      pan: formValues.pan,
      otp: formValues.otpCode,
      new_email: formValues.new_mobile_number,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: SaveVerifyOTPNewMobileUpdateMutate,
    error,
    payload,
  } = useMutation(SaveVerifyOTPNewMobileUpdateAction);

  return {
    SaveVerifyOTPNewMobileUpdateMutate,
    payload,
    error,
  };
};

const useCardAllValuehooks = () => {
  // @ts-ignore
  // const users_detail = JSON.parse(localStorage.getItem("users_detail"));
  const ModuleStatusHooksAction: any = (data: {
    type: string;
    application_number: string;
  }) => ({
    method: "GET",
    endpoint: `/v1/${data?.type}/details?${
      data?.application_number && data?.application_number.trim() !== ""
        ? `&application_number=${data?.application_number}`
        : ""
    }`,
  });
  const {
    mutate: ModuleStatusHooksMutate,
    error,
    payload,
  } = useMutation(ModuleStatusHooksAction);

  return {
    ModuleStatusHooksMutate,
    payload,
    error,
  };
};

////Get Master Income//
const useGetMasterIncomehooks = () => {
  const GetMasterIncomeAction: any = () => ({
    method: "GET",
    endpoint: `/v1/income/master`,
  });
  const {
    mutate: GetMasterIncomeMutate,
    error,
    payload,
  } = useMutation(GetMasterIncomeAction);

  return {
    GetMasterIncomeMutate,
    payload,
    error,
  };
};
////Get Master Income//

// get address
const useFetchEsignMTF = () => {
  const FetchEsignMTFAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/address/fetch-digilocker`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      id: formValues.document_id,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: FetchEsignMTFMutate,
    error,
    payload,
  } = useMutation(FetchEsignMTFAction);

  return {
    FetchEsignMTFMutate,
    payload,
    error,
  };
};
const useMTFhooks = () => {
  const SaveSegmentDeactAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/address/initiate-digilocker`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      application_number: JSON.parse(
        localStorage.getItem("application_number") || ""
      ),
      // deactivated_segments: formValues.deactivated_segments,
    },
  });
  const {
    mutate: SaveSegmentDeactMutate,
    error,
    payload,
  } = useMutation(SaveSegmentDeactAction);

  return {
    SaveSegmentDeactMutate,
    payload,
    error,
  };
};
const useEsignMTFhooks = () => {
  const EsignDeactAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/mtf/initiateEsign`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: EsignDeactMutate,
    error,
    payload,
  } = useMutation(EsignDeactAction);

  return {
    EsignDeactMutate,
    payload,
    error,
  };
};

// selfie esign
const useSelfiehooks = () => {
  const SaveSegmentDeactAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/selfie/initiate`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      application_number: JSON.parse(
        localStorage.getItem("application_number") || ""
      ),
      // deactivated_segments: formValues.deactivated_segments,
    },
  });
  const {
    mutate: SaveSegmentDeactMutate,
    error,
    payload,
  } = useMutation(SaveSegmentDeactAction);

  return {
    SaveSegmentDeactMutate,
    payload,
    error,
  };
};
//get selfie url
const useSelfieFromUrlhooks = () => {
  const SelfieFromUrlAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/selfie/send-link`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: SelfieFromUrlMutate,
    error,
    payload,
  } = useMutation(SelfieFromUrlAction);

  return {
    SelfieFromUrlMutate,
    payload,
    error,
  };
};
// get selfie fetch
const useFetchEelfie = () => {
  const FetchEsignMTFAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/selfie/fetch`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      id: formValues.document_id,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: FetchEsignMTFMutate,
    error,
    payload,
  } = useMutation(FetchEsignMTFAction);

  return {
    FetchEsignMTFMutate,
    payload,
    error,
  };
};

const useSaveDocumentDetailsMutate = () => {
  const SaveDocumentDetailsAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/document/upload`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: SaveDocumentDetailsMutate,
    error,
    payload,
  } = useMutation(SaveDocumentDetailsAction);

  return {
    SaveDocumentDetailsMutate,
    payload,
    error,
  };
};
const useSaveIncomeUpdateMutate = () => {
  const SaveIncomeUpdateAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/income/save`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: SaveIncomeUpdateMutate,
    error,
    payload,
  } = useMutation(SaveIncomeUpdateAction);

  return {
    SaveIncomeUpdateMutate,
    payload,
    error,
  };
};

const useBankNoChange = () => {
  const BankNoChangeAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/bank/no-change`,
    body: {
      pan: formValues.pan,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: BankNoChangeMutate,
    error,
    payload,
  } = useMutation(BankNoChangeAction);

  return {
    BankNoChangeMutate,
    payload,
    error,
  };
};

const useBankUpdate = () => {
  const ankUpdateAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/bank/modify`,

    body: {
      pan: formValues?.pan,
      application_number: formValues?.application_number,
      primary_bank_account: formValues?.primary_bank_account,
    },
  });
  const {
    mutate: BankUpdateMutate,
    error,
    payload,
  } = useMutation(ankUpdateAction);

  return {
    BankUpdateMutate,
    payload,
    error,
  };
};

const useAddressNoChange = () => {
  const AddressNoChangeAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/address/no-change`,
    body: {
      pan: formValues.pan,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: AddressNoChangeMutate,
    error,
    payload,
  } = useMutation(AddressNoChangeAction);

  return {
    AddressNoChangeMutate,
    payload,
    error,
  };
};

const useEmailNoChange = () => {
  const EmailNoChangeAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/email/no-change`,
    body: {
      pan: formValues.pan,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: EmailNoChangeMutate,
    error,
    payload,
  } = useMutation(EmailNoChangeAction);

  return {
    EmailNoChangeMutate,
    payload,
    error,
  };
};

const useMobileNoChange = () => {
  const MobileNoChangeAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/mobile/no-change`,
    body: {
      pan: formValues.pan,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: MobileNoChangeMutate,
    error,
    payload,
  } = useMutation(MobileNoChangeAction);

  return {
    MobileNoChangeMutate,
    payload,
    error,
  };
};
// search bank
const SearchBankhooks = () => {
  const searchBankAction: any = (data: any) => ({
    method: "GET",
    endpoint: `/v1/bank/search?search_value=${data}`,
  });
  const {
    mutate: searchBankMutate,
    error,
    payload,
  } = useMutation(searchBankAction);

  return {
    searchBankMutate,
    payload,
    error,
  };
};

const useModifyDeleteBankhooks = () => {
  const ModifyDeleteBankAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/selfie/fetch`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      id: formValues.document_id,
      application_number: formValues.application_number,
      // banks_to_delete: ["string"],
    },
  });
  const {
    mutate: ModifyDeleteBankMutate,
    error,
    payload,
  } = useMutation(ModifyDeleteBankAction);

  return {
    ModifyDeleteBankMutate,
    payload,
    error,
  };
};

// search bank
const PennyDropBankhooks = () => {
  const PennyDropBankAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/bank/penny-drop`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: PennyDropBankMutate,
    error,
    payload,
  } = useMutation(PennyDropBankAction);

  return {
    PennyDropBankMutate,
    payload,
    error,
  };
};

// Add bank
const AddBankhooks = () => {
  const AddBankAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/bank/process`,
    dataType: "jsonp",
    body: formValues,
  });
  const { mutate: AddBankMutate, error, payload } = useMutation(AddBankAction);

  return {
    AddBankMutate,
    payload,
    error,
  };
};
const useSaveNomineehooks = () => {
  const SaveNomineeAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/nominee/add`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: SaveNomineeMutate,
    error,
    payload,
  } = useMutation(SaveNomineeAction);

  return {
    SaveNomineeMutate,
    payload,
    error,
  };
};
const useValidatePanNomineehooks = () => {
  const ValidatePanNomineeAction: any = (formValues: any) => ({
    method: "GET",
    endpoint: `/v1/nominee/validate-pan?nominee_pan=${formValues?.nominee_pan?.toUpperCase()}&nominee_name=${
      formValues?.nominee_name
    }&nominee_dob=${formValues?.nominee_dob}&application_number=${
      formValues?.application_number
    }&pan=${formValues?.pan}`,
    dataType: "jsonp",
  });
  const {
    mutate: ValidatePanNomineeMutate,
    error,
    payload,
  } = useMutation(ValidatePanNomineeAction);

  return {
    ValidatePanNomineeMutate,
    payload,
    error,
  };
};

// pincode master
const usePincodeMasterhooks = () => {
  const PincodeMasterAction: any = (formValues: any) => ({
    method: "GET",
    endpoint: `/v1/nominee/pincode-details?pincode=${formValues?.pincode}`,
    dataType: "jsonp",
  });
  const {
    mutate: PincodeMasterMutate,
    error,
    payload,
  } = useMutation(PincodeMasterAction);

  return {
    PincodeMasterMutate,
    payload,
    error,
  };
};

// Upload Sign
const UploadSignhooks = () => {
  const UploadSignAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/signature/upload`,
    dataType: "jsonp",
    body: formValues,
  });
  const {
    mutate: UploadSignMutate,
    error,
    payload,
  } = useMutation(UploadSignAction);

  return {
    UploadSignMutate,
    payload,
    error,
  };
};

// get Docs
const useFetchDoc = () => {
  const FetchEsignMTFAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/document/fetch-digilocker`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      id: formValues.document_id,
      application_number: formValues.application_number,
    },
  });
  const {
    mutate: FetchEsignMTFMutate,
    error,
    payload,
  } = useMutation(FetchEsignMTFAction);

  return {
    FetchEsignMTFMutate,
    payload,
    error,
  };
};
const useDochooks = () => {
  const SaveSegmentDeactAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/document/initiate-digilocker`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      application_number: JSON.parse(
        localStorage.getItem("application_number") || ""
      ),
      // deactivated_segments: formValues.deactivated_segments,
    },
  });
  const {
    mutate: SaveSegmentDeactMutate,
    error,
    payload,
  } = useMutation(SaveSegmentDeactAction);

  return {
    SaveSegmentDeactMutate,
    payload,
    error,
  };
};

// CheckKRAhooks
// const useCheckKRAhooks = () => {
//   // @ts-ignore
//   const users_detail = JSON.parse(localStorage.getItem("users_detail"));
//   const CheckKRAAction: any = (formValues: any) => ({
//     method: "POST",
//     dataType: "jsonp",
//     endpoint: `/v1/kra/status?ucc=MT1000017`,
//     // body: {
//     //   ucc: formValues.ucc,
//     // },
//   });
//   const {
//     mutate: CheckKRAMutate,
//     error,
//     payload,
//   } = useMutation(CheckKRAAction);

//   return {
//     CheckKRAMutate,
//     payload,
//     error,
//   };
// };
const useCheckKRAhooks = () => {
  // @ts-ignore
  // const users_detail = JSON.parse(localStorage.getItem("users_detail"));
  const searchBankAction: any = (data: { type: string }) => ({
    method: "GET",
    endpoint: `/v1/kra/status`,
  });
  const {
    mutate: CheckKRAMutate,
    error,
    payload,
  } = useMutation(searchBankAction);

  return {
    CheckKRAMutate,
    payload,
    error,
  };
};

// esign final
const useFetchUpdate = () => {
  const FetchEsignMTFAction: any = (formValues: any) => ({
    method: "POST",
    endpoint: `/v1/esign/fetch-esign`,
    dataType: "jsonp",
    body: {
      pan: formValues.pan,
      id: formValues.document_id,
      form_type: formValues.form_type,
      application_number: formValues.application_number,
      settlement_type: formValues.settlement_type,
    },
  });
  const {
    mutate: FetchEsignMTFMutate,
    error,
    payload,
  } = useMutation(FetchEsignMTFAction);

  return {
    FetchEsignMTFMutate,
    payload,
    error,
  };
};
const useEsignMainKYC = () => {
  const SaveVerifyOTPNewMobileUpdateAction: any = (formValues: any) => ({
    method: "POST",
    dataType: "jsonp",
    endpoint: `/v1/esign/initiate-esign`,
    body: {
      pan: formValues.pan,
      form_type: formValues.form_type,
      application_number: formValues.application_number,
      settlement_type: formValues.settlement_type,
    },
  });
  const {
    mutate: SaveEsignMainKYCMobileMutate,
    error,
    payload,
  } = useMutation(SaveVerifyOTPNewMobileUpdateAction);

  return {
    SaveEsignMainKYCMobileMutate,
    payload,
    error,
  };
};

////Get Bulletin//
const useGetBulletinHooks = () => {
  const GetBulletinAction: any = () => ({
    method: "GET",
    endpoint: `/v1/news?platform=rekyc`,
  });
  const {
    mutate: GetBulletinMutate,
    error,
    payload,
  } = useMutation(GetBulletinAction);

  return {
    GetBulletinMutate,
    payload,
    error,
  };
};

export {
  ////
  useSendOTPhooks,
  useVerifyOTPhooks,
  useStepStatushooks,
  useVerifyOTPNewMobileMutate,
  useSendOTPNewMobilehooks,
  useSendOTPNewEmailhooks,
  useVerifyOTPNewEmailMutate,
  useCardAllValuehooks,
  useFetchEsignMTF,
  useMTFhooks,
  useEsignMTFhooks,
  useSaveDocumentDetailsMutate,
  useGetMasterIncomehooks,
  useSaveIncomeUpdateMutate,
  useBankNoChange,
  useAddressNoChange,
  useEmailNoChange,
  useMobileNoChange,
  SearchBankhooks,
  useSelfiehooks,
  useFetchEelfie,
  useModifyDeleteBankhooks,
  PennyDropBankhooks,
  AddBankhooks,
  useSelfieFromUrlhooks,
  useSaveNomineehooks,
  UploadSignhooks,
  useFetchDoc,
  useDochooks,
  useCheckKRAhooks,
  useValidatePanNomineehooks,
  useBankUpdate,
  useFetchUpdate,
  useEsignMainKYC,
  useGetBulletinHooks,
  usePincodeMasterhooks,
  useTwoWayAuthVerificationhooks,
};
